import { IDisciplinasEletivasComponentProps } from '@/@types/Graduacao/DisciplinasEletivas';
import { Loading } from '@/components/shared/Loading';
import { AlertMessage } from '@/components/shared/AlertMessage';
import { InputWithLabel } from '@/components/shared/InputWithLabel';
import { Button } from '@/components/shared/Button';
import { Link } from 'react-router-dom';
import { CardHeader } from '@/components/shared/CardHeader';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';


/**
 * Componente para exibir as disciplinas eletivas.
 * @param isLoading Indica se os dados estão sendo carregados.
 * @param ano O ano do catálogo de disciplinas.
 * @param data As disciplinas eletivas a serem exibidas.
 * @param setAno Função para atualizar o ano do catálogo.
 * @returns O componente de disciplinas eletivas.
 */

const DisciplinasEletivasComponent= ({ isLoading, ano, data, setAno }: IDisciplinasEletivasComponentProps) => {
    return (
        <div className='border-[1px] mt-[16px] rounded-[0.25rem] '>
                <CardHeader className='mb-[16px] flex-col'>
                    <InputWithLabel
                        label='Ano Catálogo'
                        type='number'
                        value={ano}
                        onChange={({ target }) => setAno(parseInt(target.value))}
                    />
                    <p className='mt-[16px]'><strong className='text-gray-600 font-semibold'>Disciplinas Eletivas I:</strong> O aluno deve obter 18 créditos dentre as disciplinas listadas abaixo.</p>
                </CardHeader>


            {
                isLoading ? (
                    <Loading color='primary' />
                ) : (

                    data.length > 0 ? (
                        <>
                            <Table className='text-md'>

                                <TableHeader>
                                    <TableRow>
                                        <TableHead>Cód da Disciplina</TableHead>
                                        <TableHead>Crédito</TableHead>
                                        <TableHead>Nome da Disciplina</TableHead>
                                        <TableHead>Programa</TableHead>
                                    </TableRow>
                                </TableHeader>

                                <TableBody>
                                    {data.map(disciplina => {

                                        // verifica se a disciplina não é uma das obrigatórias antes de renderizar
                                        if (!['FA100', 'FA070', 'FA071'].includes(disciplina.COD_DISC)) {

                                            // extrai o número da sigla da disciplina
                                            const numCode = parseInt(disciplina.COD_DISC.substring(2));

                                            // renderiza apenas disciplinas entre 1 e 132
                                            if (numCode >= 1 && numCode <= 132) {
                                                return (
                                                    <TableRow className='font-normal'>
                                                        <TableCell><a className='font-bold hover:text-colorSecondary transition-all duration-75' target='_blank' href={`${disciplina.ANO_CATAL > 2020 ? disciplina.URL2021 : disciplina.URL2020}`}>{disciplina.COD_DISC}</a></TableCell>

                                                        <TableCell>{disciplina.NUM_CRED_DISCI}</TableCell>

                                                        <TableCell>{disciplina.NOME_DISCI}</TableCell>

                                                        <TableCell className='flex justify-center'>
                                                            <Link target='_blank' to={`/extranet/academico/graduacao/disciplinas/programa/${disciplina.ANO_CATAL}/${disciplina.COD_DISC}`}>
                                                                <Button variant='secondary' className='flex-col p-4'>
                                                                    <i className='fas fa-search'></i>
                                                                    Programa
                                                                </Button>
                                                            </Link>
                                                        </TableCell>

                                                    </TableRow>
                                                );

                                            }

                                        }

                                    })}

                                </TableBody>
                            </Table>
                        </>

                    ) : (
                        <>
                            <AlertMessage message='Não foi encontrada nenhuma matriz curricular.' />
                        </>
                    )
                )
            }

        </div>
    );
}

export { DisciplinasEletivasComponent };